export enum SetUpNotificationSteps {
  selectCategories = 'Select Categories',
  categoriesDetails = 'Categories Details',
}
